import React from "react";
import { getMessage } from "CONFIG/i18n";

import ic_fullscreen from "ASSETS/Images/video_menu/ic_switch_full_screen.svg";

const FullScreenMenu = (props) => {
  const handleFullScreen = () => {
    props.handleFullScreen();
  }
    
  return (
    <div className="p-2" onClick={handleFullScreen}>
      <img
        src={ic_fullscreen}
        id="videoMenu"
        width={28}
        height={28}
        title={getMessage("SCREEN_ZOOMIN")}
      />
    </div>
  )
}

export default FullScreenMenu;